import { cn } from '@/lib/utils';
import * as LabelPrimitive from '@radix-ui/react-label';
import { Label } from 'ui/label';
import { useFieldState } from '.';

export function FormLabel(props: React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>) {
  const { className, ...rest } = props;
  const { formItemId, isRequired } = useFieldState();

  return (
    <div className="flex">
      <Label className={cn('font-bold', className)} htmlFor={formItemId} {...rest} />

      {isRequired && <span className="text-destructive-text leading-[100%]">*</span>}
    </div>
  );
}
